(function($) {
  const contentListings = Array.from(document.querySelectorAll(".content-listing__list"));

  /**
   * @description - Function checks if listing should be changed to slider on mobile and init slider if so
   */
  const slidersInit = () => {
    contentListings.forEach(item => {
      const slider = $(item);

      if ($(window).width() < 600) {
        if (!$(this).hasClass("slick-initialized")) {
          slider.slick({
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            responsive: [
              {
                breakpoint: 600,
                settings: "unslick"
              }
            ]
          });
        }
      }
    });
  };

  /**
   * Initialize functions on start and on resize
   */
  $(window).on("resize", () => {
    slidersInit();
  });

  $(document).ready(() => {
    slidersInit();
  });
})(jQuery);
